// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-count {\n  width: \"fit-content\";\n  padding: 0 5px;\n  height: 24px;\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  background-color: rgba(51, 51, 51, 0.7);\n  border-radius: 3px;\n  color: #ffffff;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n.slide-count .count-icon {\n  width: 16px;\n  height: 16px;\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
